export default "__VITE_ASSET__381fa0ef__"